import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import ContentRow from '../components/ContentRow';
import ContentModal from '../components/ContentModal';
import Footer from '../components/Footer';
import { Search as SearchIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KID_RATINGS = ['Tout public', '7+', '10+'];
const kidAllow = c => c && (c.type === 'jeunesse' || c.type === 'game' || (c.categories || []).includes('jeunesse') || c.category === 'jeunesse');

export default function SearchPage() {
  const { activeProfile } = useAuth();
  const isKid = KID_RATINGS.includes(activeProfile?.max_age_rating);
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalContentId, setModalContentId] = useState(null);
  const [modalSource, setModalSource] = useState(null);

  useEffect(() => {
    if (!query) return;
    const fetchResults = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${API}/search?q=${encodeURIComponent(query)}`, { withCredentials: true });
        setResults(isKid ? (data || []).filter(kidAllow) : data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchResults();
  }, [query]);

  const openModal = (id, rect) => { setModalContentId(id); setModalSource(rect || null); };

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(180deg, #11041F 0%, #382C4E 100%)' }} data-testid="search-page">
      <Header />
      <div className="pt-24 px-6 md:px-16">
        {query ? (
          <>
            <h1 className="text-2xl font-semibold font-['Manrope'] text-white mb-8" data-testid="search-title">
              Résultats pour "{query}"
            </h1>
            {loading ? (
              <div className="flex justify-center py-20">
                <div className="w-8 h-8 border-2 border-[#E9641A]/30 border-t-[#E9641A] rounded-full animate-spin" />
              </div>
            ) : results.length > 0 ? (
              <ContentRow title="" items={results} onOpenModal={openModal} />
            ) : (
              <div className="text-center py-20" data-testid="no-results">
                <SearchIcon size={48} className="text-white/20 mx-auto mb-4" />
                <p className="text-white/50">Aucun résultat trouvé pour "{query}"</p>
              </div>
            )}
          </>
        ) : (
          <div className="text-center py-20">
            <SearchIcon size={48} className="text-white/20 mx-auto mb-4" />
            <p className="text-white/50">Recherchez des films, séries, documentaires...</p>
          </div>
        )}
      </div>
      <Footer />
      {modalContentId && (
        <ContentModal contentId={modalContentId} onClose={() => setModalContentId(null)} sourceRect={modalSource} />
      )}
    </div>
  );
}
